"use client";
import React from "react";
import Image from "next/image";
import SelectedUniversity from "@packages/shared-components/sr-page/SrFilter/selecteduniversity";
import Accordion from "@packages/shared-components/common-utilities/accordion/accordion";
import { useFilterContext } from "@packages/lib/utlils/use-context/filter-context";
const UniversityAccordianFilter = ({
  keyName,
  formUrl,
  appendSearchParams,
  universityClicked,
  universitiesList,
  jsondata,
}: any) => {
  const {
    universityState,
    setUniversityState,
    filterState,
    prepopulateFilter,
    setPrepopulateFilter,
  } = useFilterContext();

  const universityKeywordSearch = (keyword: string) => {
    if (keyword?.length >= 3) {
      const filteredUni = jsondata?.universityFilterList?.filter((uni: any) =>
        uni?.collegeNameDisplay?.toLowerCase().includes(keyword?.toLowerCase())
      );
      setUniversityState((prev: any) => ({
        ...prev,
        universityKeyword: keyword,
        isUniversityDropdownOpen: true,
        sortedUni: filteredUni,
      }));
    } else if (keyword?.length < 3) {
      setUniversityState((prev: any) => ({
        ...prev,
        universityKeyword: keyword,
        isUniversityDropdownOpen: false,
      }));
    }
  };
  return (
    <>
      {jsondata?.universityFilterList?.length > 0 && (
        <Accordion
          title="University"
          id="#university"
          defaultOpenStatus={
            filterState?.selectedFilter === "university" ||
            filterState?.selectedFilter === "all"
          }
        >
          <div className="flex flex-col gap-[16px] pt-[24px]">
            <div className="flex flex-col gap-[4px]">
              <div className="text-para-lg font-semibold">
                Find a university
              </div>
              <div className="x-small font-semibold text-black uppercase">
                Choose one
              </div>
            </div>
            <div className="bg-white rounded-[22px] p-[11px_12px] border border-grey-300 hover:border-primary-500 md:p-[9px_12px]">
              <div className="flex item-center gap-[12px] relative">
                <Image
                  src="/static/assets/icons/search-result/search-black.svg"
                  width="20"
                  height="20"
                  alt="Search icon"
                />
                <input
                  type="text"
                  className="w-full focus:outline-none small text-black placeholder:text-gray-500"
                  aria-label="enter keyword"
                  placeholder="Search universities"
                  onChange={(event) => {
                    universityKeywordSearch(event?.target?.value);
                  }}
                  value={universityState?.universityKeyword || ""}
                />
                {universityState?.isUniversityDropdownOpen && (
                  <div className="flex flex-col w-[calc(100%_+_28px)] absolute z-[1] bg-white shadow-custom-3 rounded-[8px] left-[-15px] top-[33px] custom-scrollbar-2 max-h-[367px] overflow-y-auto">
                    {universityState?.sortedUni?.length > 0 ? (
                      <ul>
                        {universityState?.sortedUni?.map(
                          (sortedUniItem: any, index: number) => (
                            <li
                              key={index + 1}
                              className="px-[16px] py-[10px] block small hover:bg-blue-50 hover:underline cursor-pointer"
                              onClick={() => {
                                appendSearchParams(
                                  keyName?.university,
                                  sortedUniItem?.collegeTextKey
                                );
                              }}
                            >
                              {sortedUniItem?.collegeNameDisplay}
                            </li>
                          )
                        )}
                      </ul>
                    ) : (
                      <p>No match found</p>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div
              className={`flex flex-col gap-[12px] transition-all duration-300 ease-in-out ${
                universityState?.isUniversityOpen
                  ? "-translate-x-full h-0 hidden"
                  : "translate-x-0 h-auto"
              }`}
            >
              {universitiesList?.map((uniItem: any, index: number) => (
                <div
                  key={index}
                  onClick={() => {
                    universityClicked(
                      uniItem?.displayHeading,
                      uniItem?.id,
                      true
                    );
                  }}
                  className="flex items-center gap-[4px] text-blue-400 small font-semibold cursor-pointer hover:underline"
                >
                  {uniItem?.name}
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M4.48037 14.6192C3.97269 14.1116 3.97269 13.2884 4.48037 12.7808L8.76113 8.5L4.48037 4.21924C3.97269 3.71156 3.97269 2.88844 4.48037 2.38076C4.98805 1.87308 5.81117 1.87308 6.31885 2.38076L11.5188 7.58076C12.0265 8.08844 12.0265 8.91156 11.5188 9.41924L6.31885 14.6192C5.81117 15.1269 4.98805 15.1269 4.48037 14.6192Z"
                      fill="#4664DC"
                    />
                  </svg>
                </div>
              ))}
            </div>
            <div
              className={`bg-white transition-all duration-300 ease-in-out 
                      ${
                        universityState?.isUniversityOpen
                          ? "translate-x-0 block"
                          : "-translate-x-full hidden"
                      }
                    `}
            >
              {universitiesList?.map((university: any, index: number) => (
                <SelectedUniversity
                  key={index + 1}
                  formUrl={formUrl}
                  id={university?.id}
                  universityState={universityState}
                  universityList={university?.unilist}
                  universityClicked={universityClicked}
                  appendSearchParams={appendSearchParams}
                  prepopulateFilter={prepopulateFilter}
                  setPrepopulateFilter={setPrepopulateFilter}
                />
              ))}
            </div>
          </div>
        </Accordion>
      )}
    </>
  );
};

export default UniversityAccordianFilter;
